export default '/annuaire/search/*'